import { Machine, assign } from 'xstate';

const fetchFleets = fetchAll => (context, event) => fetchAll({
  path: '/fleets',
  queryParams: {
    startDatetime: [context && context.startDatetime],
    endDatetime: [context && context.endDatetime],
    sources: context.filters.sources,
    trains: context.filters.trains,
    signalNames: context.filters.signalNames
  }
});
const fetchTrains = fetchAll => (context, event) => fetchAll({
  path: '/trains',
  queryParams: {
    startDatetime: [context && context.startDatetime],
    endDatetime: [context && context.endDatetime],
    sources: context.filters.sources,
    fleets: context.filters.fleets,
    signalNames: context.filters.signalNames
  }
});
const fetchSources = fetchAll => (context, event) => fetchAll({
  path: '/sources',
  queryParams: {
    startDatetime: [context && context.startDatetime],
    endDatetime: [context && context.endDatetime],
    fleets: context.filters.fleets,
    trains: context.filters.trains,
    signalNames: context.filters.signalNames
  }
});
const fetchSignals = fetchAll => (context, event) => fetchAll({
  path: '/signals',
  queryParams: {
    startDatetime: [context && context.startDatetime],
    endDatetime: [context && context.endDatetime],
    fleets: context.filters.fleets,
    trains: context.filters.trains,
    sources: context.filters.sources
  }
});
const fetchDisplayed = fetchAll => (context, event) => fetchAll({
  path: '/data',
  queryParams: {
    startDatetime: [context && context.startDatetime],
    endDatetime: [context && context.endDatetime],
    fleets: context.filters.fleets,
    trains: context.filters.trains,
    sources: context.filters.sources,
    signalNames: context.filters.signalNames
  }
});
/** reset filter properties */
const setProperty = name => assign({
  filters: (context, event) => {
    return ({
      ...context.filters,
      [name]: event[name]
    })
  }
});
/**
 * State machine for handling controller state more clearly
 * https://xstate.js.org/
 * @param {fetching data function} param0 
 */
export const fetchMachine = ({ fetchAll }) => {

  const fetchNeededData = async (context, event) => {
    try {
      // TODO: train has to be selected - put a guard
      const fleets = await fetchFleets(fetchAll)(context, event);

      const trains = await fetchTrains(fetchAll)(context, event);
      if (context.filters.trains.length == 0) {
        return { fleets, trains, data: [], signalNames: [], sources: [] }
      }

      const sources = await fetchSources(fetchAll)(context, event);

      const signalNames = await fetchSignals(fetchAll)(context, event);
      if (context.filters.signalNames.length == 0) {
        return { fleets, trains, sources, signalNames, data: [], }
      }

      const data = await fetchDisplayed(fetchAll)(context, event);
      return { fleets, trains, sources, signalNames, data }
    } catch (err) {
      console.log(err)
    }
  }

  return Machine({
    id: 'fetchingMachine',
    initial: 'selectDates',
    context: {
      startDatetime: DateTime.utc().minus({days: 1}).toISO(),
      endDatetime: DateTime.utc().toISO(),
      data: {
        trains: [],
        fleets: [],
        signals: [],
        signalNames: [],
      },
      filters: {
        trains: [],
        fleets: [],
        sources: [],
        signalNames: [],
      },
      retries: 0
    },
    states: {
      selectDates: {
        on: {
          FETCH_TRAINS: 'fetchData',
          SET_DATES: {
            target: 'selectDates',
            actions: [assign({ startDatetime: (_, event) => event.startDate }),
              assign({ endDatetime: (_, event) => event.endDate })]
          }
        }
      },

      fetchData: {
        invoke: {
          id: 'fetchData',
          src: fetchNeededData,
          onDone: {
            target: 'done',
            actions: [assign({
              fleets: (_, { fleets }) => fleets || [],
              trains: (_, { trains }) => trains || [],
              sources: (_, { sources }) => sources || [],
              signalNames: (_, { signalNames }) => signalNames || [],
              data: (_, { data }) => data || []
            })]
          },
          onError: 'failure'
        },
      },
      done: {
        // TODO: target is different
        // - select train
        // - select fleet
        // - select signals -> fetch actual data
        on: {
          FETCH_DATA: 'fetchData',
          SET_DATES: {
            target: 'fetchData',
            actions: [assign({ startDatetime: (context, event) => event.startDate }),
              assign({ endDatetime: (context, event) => event.endDate })]
          },
          SET_TRAINS: {
            target: 'fetchData',
            actions: [setProperty('trains')]
          },
          RESET_FILTERS: {
            target: 'fetchData',
            actions: [ ]
          },
          SET_FLEETS: {
            target: 'fetchData',
            actions: [setProperty('fleets')]
          },
          SET_SOURCES: {
            target: 'fetchData',
            actions: [setProperty('sources')]
          },
          SET_SIGNALS: {
            target: 'fetchData',
            actions: [setProperty('signalNames')]
          }
        }
      },
      failure: {
        on: {
          RETRY: 'fetchData',
        }
      },
    }
  })
};